<template>
  <b-row>
    <b-col
      v-for="(item, index) in itensPauta"
      :key="index"
      cols="12"
      md="6"
      lg="6"
      class="d-flex"
    >
      <b-card class="w-100 mb-1">
        <b-card-title align="center">
          {{ item.descricao }}
        </b-card-title>
        <vue-apex-charts
          v-if="
            resultadosComputados[item.id] &&
              resultadosComputados[item.id].series.length > 0
          "
          type="donut"
          height="300"
          class="my-1"
          :options="resultadosComputados[item.id].chartOptions"
          :series="resultadosComputados[item.id].series"
        />
        <b-alert
          v-else
          show
          variant="info"
          class="text-center p-3"
        >
          <p class="text center">
            Nenhum dado para exibir no momento
          </p>
        </b-alert>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { $themeColors } from '@themeConfig'
import VueApexCharts from 'vue-apexcharts'
import AssembleiaAPI from '@/api/assembleia'

export default {
  components: {
    VueApexCharts,
  },
  props: {
    assembleia: {
      type: Object,
      required: true,
    },
    itensPauta: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      resultadosComputados: [],
    }
  },
  async created() {
    this.fetchResultados()
  },
  methods: {
    async fetchResultados() {
      const res = await AssembleiaAPI.listResultado(this.assembleia.id, {})

      this.resultadosComputados = []

      this.itensPauta.forEach(itemPauta => {
        const votosItem = res.data.content.filter(
          c => c.itemPautaId === itemPauta.id,
        )

        this.resultadosComputados[itemPauta.id] = {
          votos: [],
          series: [],
          chartOptions: {
            chart: {
              toolbar: {
                show: false,
              },
            },
            labels: [],
            dataLabels: {
              enabled: true,
            },
            legend: { show: true, position: 'bottom' },
            stroke: { width: 0 },
            colors: [
              $themeColors.primary,
              $themeColors.secondary,
              $themeColors.dark,
              $themeColors.warning,
              $themeColors.danger,
            ],
          },
        }

        if (itemPauta.opcoesVoto && itemPauta.opcoesVoto.length > 0) {
          itemPauta.opcoesVoto.forEach(opcao => {
            const resultadoItem = votosItem.filter(
              c => c.opcaoVotoId === opcao.id,
            )

            const quantidadeVotos = (resultadoItem
                && resultadoItem.length > 0
                && resultadoItem[0].quantidade)
              || 0

            this.resultadosComputados[itemPauta.id].series.push(quantidadeVotos)
            this.resultadosComputados[itemPauta.id].chartOptions.labels.push(
              opcao.titulo,
            )

            this.resultadosComputados[itemPauta.id].votos.push({
              nome: opcao.titulo,
              resultado: quantidadeVotos,
            })
          })
        }
      })
    },
  },
}
</script>
